import { Account, Config } from "@/api/account";
import { appUser } from "@/api/appUser.js";
import axios from "axios";

const state = {
  AC_token: localStorage.getItem("AC_token"),
  AC_userdata: JSON.parse(localStorage.getItem("AC_userdata")) || {},
  AC_config: JSON.parse(localStorage.getItem("AC_config")) || {},
  CannedResponse: null,
};

const actions = {
  cms_login({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      Account.cms_login(payload)
        .then((res) => {
          if (res.status === 200) {
            commit("setUser", res.data);
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + res.data.token;
            // 登入成功後 直接 SetAgentState state: "AUXBreak"

            dispatch("updateState", { state: "AUXBreak" });
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          localStorage.removeItem("AC_userdata");
          reject(err);
        });
    });
  },
  login({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      Account.login(payload)
        .then((res) => {
          if (res.status === 200) {
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + res.data.token;

            commit("setUser", res.data);
            // 登入成功後 直接 SetAgentState state: "AUXBreak"
            dispatch("updateState", { state: "AUXBreak" });
            resolve(res);
          } else {
            reject(res);
          }

          // init axios default header after login !
          // 因第一次登入還未取得 token 設定 Authorization
        })
        .catch((err) => {
          // console.log('catch', err);
          localStorage.removeItem("AC_userdata");
          reject(err);
        });
    });
  },
  logout({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("updateState", payload)
        .then((res) => {
          if (res.status == 200) {
            // console.log('2. cleanUser');
            // clear your user's token from localstorage
            // dispatch("internalChat/stopConnection", {}, { root: true });
            // dispatch("clientChat/stopConnection", {}, { root: true });
            resolve(res);
          }
        })
        .finally(() => {
          commit("cleanUser");
          // remove the axios default header
          delete axios.defaults.headers.common["Authorization"];
        });
    });
  },
  updateState({ commit }, payload) {
    return new Promise((resolve, reject) => {
      appUser
        .SetAgentState(payload)
        .then((res) => {
          commit("setUser", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getConfig({ commit }) {
    Config.get().then((res) => {
      // console.log('getConfig', res);
      commit("setConfig", res.data);
    });
  },
  updateAvatar({ commit }, paylaod) {
    return new Promise((resolve, reject) => {
      Account.UpdateAvatar(paylaod)
        .then((res) => {
          commit("setUser", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  update({ commit }, paylaod) {
    return new Promise((resolve, reject) => {
      Account.Update(paylaod)
        .then((res) => {
          console.log(res);
          commit("setUser", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  getAllCannedResponse({ commit }) {
    return new Promise((resolve, reject) => {
      Account.GetAllCannedResponse()
        .then((res) => {
          // console.log('getAllCannedResponse', res);
          commit("saveCannedResponse", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  addCannedResponse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Account.AddCannedResponse(payload)
        .then((res) => {
          // console.log(res.data);
          commit("saveCannedResponse", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  updateCannedResponse({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      Account.EditCannedResponse(id, data)
        .then((res) => {
          // console.log(res.data);
          commit("saveCannedResponse", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  deleteCannedResponse({ commit }, id) {
    return new Promise((resolve, reject) => {
      Account.DeleteCannedResponse(id)
        .then((res) => {
          // console.log(res.data);
          commit("saveCannedResponse", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
  searchCannedResponse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Account.SearchCannedResponse(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          reject(err);
        });
    });
  },
};
const mutations = {
  cleanUser(state) {
    // console.log('cleanUser');
    state.AC_userdata = {};
    state.AC_token = "";
    state.AC_config = {};
    localStorage.removeItem("AC_userdata");
    localStorage.removeItem("AC_token");
    localStorage.removeItem("AC_config");
    // localStorage.removeItem("AC_lan"); // language 保留
  },
  setUser(state, payload) {
    state.AC_userdata = Object.assign(state.AC_userdata, payload);
    state.AC_token = state.AC_userdata.token;
    state.AC_userdata.state = payload.state;

    localStorage.setItem("AC_token", state.AC_userdata.token);
    localStorage.setItem("AC_userdata", JSON.stringify(state.AC_userdata));
    localStorage.setItem("AC_lan", state.AC_userdata.language);
  },
  // AP-12933 GET /api/Account 每次即時回傳專員所屬國家的列表保留設定
  setChatListFilter(state, payload) {
    if (!state.AC_token) return; // 回應晚於登出時不寫回
    const { isChatListFilterByFinishTime, chatListFinishedKeepMinutes } =
      payload;
    state.AC_userdata = {
      ...state.AC_userdata,
      isChatListFilterByFinishTime,
      chatListFinishedKeepMinutes,
    };
    localStorage.setItem("AC_userdata", JSON.stringify(state.AC_userdata));
  },
  setConfig(state, payload) {
    state.AC_config = payload;
    localStorage.setItem("AC_config", JSON.stringify(payload));
  },
  saveCannedResponse(state, payload) {
    state.CannedResponse = payload;
  },
};

const getters = {
  token: (state) => {
    return state.AC_userdata.token;
  },
  isAuthenticated: (state) => {
    return !!state.AC_token;
  },
  isabledRegion: (state) => {
    let roles = state.AC_userdata.roles;
    let isable = roles.includes("Director") || roles.includes("Administrator");
    return isable;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
